var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTt = function SvgIconTt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M6.498 1.332a12 12 0 0 0-2.983 2.182c-.9.9-1.628 1.909-2.182 2.983l7.716 8.454 8.454 7.716a12 12 0 0 0 2.983-2.182c.9-.9 1.627-1.909 2.182-2.983l-7.716-8.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.486 20.486q.755-.756 1.347-1.604L5.12 2.167a12.1 12.1 0 0 0-2.952 2.952l16.715 16.714q.846-.593 1.604-1.347"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.514 20.487c3.786 3.786 9.472 4.512 13.988 2.181L1.332 6.498C-.997 11.016-.27 16.702 3.515 20.487M20.485 3.515C16.699-.271 11.013-.998 6.497 1.333l16.17 16.17c2.33-4.517 1.604-10.202-2.182-13.988"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTt;